import React from 'react';
import './ui.css';

/** Shimmering block. The handoff calls for skeleton rows, never a blocking page spinner. */
export function SkeletonBlock({ width = '100%', height = 12, radius = 6, className = '' }) {
  return (
    <span
      className={`sv-skeleton ${className}`}
      style={{ width, height, borderRadius: radius }}
      aria-hidden="true"
    />
  );
}

/**
 * Table loading state — rows at the real 44px height so the card does not jump
 * when the data lands.
 */
export function TableSkeleton({ columns, rows = 8, selectable = true }) {
  return (
    <>
      {Array.from({ length: rows }).map((_, r) => (
        <div className="sv-table__row is-skeleton" key={r} style={{ cursor: 'default' }}>
          {selectable && (
            <div className="sv-table__cell sv-table__cell--check">
              <SkeletonBlock width={14} height={14} radius={4} />
            </div>
          )}
          {columns.map((col, c) => (
            <div
              className="sv-table__cell"
              key={col.key || c}
              style={{ width: col.width, flex: col.width ? '0 0 auto' : 1 }}
            >
              <SkeletonBlock width={`${45 + ((r * 7 + c * 13) % 45)}%`} height={11} />
            </div>
          ))}
        </div>
      ))}
    </>
  );
}

export default SkeletonBlock;
